import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { Form, Button, Input } from "semantic-ui-react";
import PropTypes from "prop-types";
import ForgotPasswordStore from "../stores/ForgotPasswordStore";
import FlashMessageStore from "~/stores/FlashMessageStore";
import FlashMessage from "~/components/FlashMessage";

@observer
class ForgotPasswordForm extends Component {
  render() {
    const { flashMessageStore, forgotPasswordStore, t } = this.props;

    return (
      <div>
        <h1>{t("login:forgotPassword")}</h1>
        {forgotPasswordStore.isResetPasswordSuccess && (
          <>
            <p>{forgotPasswordStore.resetPasswordSuccessMessage}</p>{" "}
            <p>
              <Link to="/">{t("login:backToLogin")}</Link>
            </p>
          </>
        )}
        {!forgotPasswordStore.isResetPasswordSuccess && (
          <>
            <FlashMessage flashMessageStore={flashMessageStore} />
            <p className="forgot-password-message">
              {t("login:enterEmailAddressUsernamePress")} &quot;{t("login:go")}&quot; {t("login:toRecoverPassword")}
            </p>
            <Form
              loading={forgotPasswordStore.isLoading}
              error={flashMessageStore.message && flashMessageStore.type === "negative"}
            >
              <Form.Field error={forgotPasswordStore.isResetPasswordError}>
                <label className="forgot-password-email-label">{t("login:emailUsername")}</label>
                <Input
                  icon="user"
                  iconPosition="left"
                  placeholder={t("login:emailOrUsername")}
                  value={forgotPasswordStore.usernameOrEmail}
                  onChange={data => {
                    forgotPasswordStore.usernameOrEmail = data.target.value;
                  }}
                />
              </Form.Field>
              <Button
                primary
                fluid
                type="submit"
                className="forgot-password-btn"
                disabled={forgotPasswordStore.usernameOrEmail.length === 0}
                onClick={() => {
                  forgotPasswordStore.isLoading = true;
                  forgotPasswordStore
                    .resetPasswordForUsername(forgotPasswordStore.usernameOrEmail)
                    .then(data => {
                      forgotPasswordStore.isLoading = false;
                      if (typeof data.data.disambiguation !== "undefined") {
                        forgotPasswordStore.isLoading = true;
                        forgotPasswordStore.loadEmailDisambiguation(forgotPasswordStore.usernameOrEmail).finally(() => {
                          forgotPasswordStore.isLoading = false;
                        });
                      } else {
                        forgotPasswordStore.resetPasswordSuccessMessage = data.data.message;
                        forgotPasswordStore.isResetPasswordSuccess = true;
                      }
                    })
                    .catch(data => {
                      forgotPasswordStore.isLoading = false;
                      flashMessageStore.setMessage(data.message, "negative");
                      forgotPasswordStore.isResetPasswordError = true;
                    });
                }}
              >
                {t("login:go")}
              </Button>
              <p className="forgot-password-back-to-login">
                <Link to="/">{t("login:backToLogin")}</Link>
              </p>
            </Form>
          </>
        )}
      </div>
    );
  }
}

ForgotPasswordForm.propTypes = {
  forgotPasswordStore: PropTypes.instanceOf(ForgotPasswordStore).isRequired,
  flashMessageStore: PropTypes.instanceOf(FlashMessageStore).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ForgotPasswordForm);
